import {
  type DefaultExtensionType,
  FileIcon as FileIconBase,
  defaultStyles,
} from 'react-file-icon';
import { FolderTwoTone as FolderIcon } from '@mui/icons-material';
import FileIconWrapper from './FileIconWrapper';
import UnknownFileIcon from './UnknownFileIcon';
import GoogleFileIcon, { GOOGLE_MIME_TYPE_PREFIX } from './GoogleFileIcon';
import { red } from '@mui/material/colors';

type FileIconProps = {
  filename: string;
  mimeType: string | null;
};

const FileIcon = ({ filename, mimeType }: FileIconProps) => {
  const hasExtension = filename.includes('.');

  if (mimeType === null) {
    return (
      <FileIconWrapper>
        <FolderIcon />
      </FileIconWrapper>
    );
  }

  if (mimeType.startsWith(GOOGLE_MIME_TYPE_PREFIX)) {
    return <GoogleFileIcon mimeType={mimeType} />;
  }

  if (!hasExtension) {
    return <UnknownFileIcon />;
  }

  const splitFilename = filename.split('.');
  const extension = splitFilename[splitFilename.length - 1];

  let styles = defaultStyles[extension as DefaultExtensionType];

  if (!styles) {
    return <UnknownFileIcon />;
  }

  if (styles.type === 'image') {
    styles = {
      ...styles,
      glyphColor: 'white',
      color: red[500],
    };
  }

  return (
    <FileIconWrapper>
      <FileIconBase extension={extension} {...styles} />
    </FileIconWrapper>
  );
};

export default FileIcon;
